import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "member-area"
}
const _hoisted_2 = { class: "member" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src", "alt", "onClick"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.teamMembers.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "character",
            src: _ctx.characterIconSrc(_ctx.character),
            alt: _ctx.displayName(_ctx.character)
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            class: "vision",
            src: _ctx.characterVisionIconSrc(_ctx.character),
            alt: "vision"
          }, null, 8, _hoisted_4)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (member) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "member",
            key: member
          }, [
            _createElementVNode("img", {
              class: "character",
              src: _ctx.characterIconSrc(member),
              alt: _ctx.displayName(member),
              onClick: ($event: any) => (_ctx.removeFromTeamOnClick(member))
            }, null, 8, _hoisted_5),
            _createElementVNode("img", {
              class: "vision",
              src: _ctx.characterVisionIconSrc(member),
              alt: "vision"
            }, null, 8, _hoisted_6)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}